export const getUsernameFromUrl = (url: string) => {
  // Twitter / X
  if (url.includes('twitter.com') || url.includes('x.com')) {
    const parts = url.split('/')
    return parts[parts.length - 1]
  }

  // Facebook
  if (url.includes('facebook.com')) {
    const usernameStartIndex = url.indexOf('com/') + 4
    const usernameEndIndex = url.indexOf('/', usernameStartIndex)
    return url.substring(
      usernameStartIndex,
      usernameEndIndex !== -1 ? usernameEndIndex : undefined,
    )
  }

  // Instagram
  if (url.includes('instagram.com')) {
    const usernameStartIndex = url.indexOf('com/') + 4
    const usernameEndIndex = url.indexOf('/', usernameStartIndex)
    return url.substring(
      usernameStartIndex,
      usernameEndIndex !== -1 ? usernameEndIndex : undefined,
    )
  }

  // Reddit
  if (url.includes('reddit.com')) {
    const parts = url.split('/')
    return parts[parts.length - 2]
  }

  // LinkedIn
  if (url.includes('linkedin.com')) {
    const normalizedUrl = url.startsWith('http') ? url : `https://${url}`
    try {
      const { pathname } = new URL(normalizedUrl)
      const segments = pathname.split('/').filter(Boolean)
      if (
        segments.length >= 2 &&
        (segments[0].toLowerCase() === 'in' ||
          segments[0].toLowerCase() === 'company')
      ) {
        return segments[1]
      }
      if (segments.length >= 1 && segments[0].toLowerCase() === 'in') {
        return segments[segments.length - 1]
      }
    } catch (error) {
      return undefined
    }
  }

  // Pinterest
  if (url.includes('pinterest.com')) {
    const parts = url.split('/')
    const username = parts[parts.length - 1] || parts[parts.length - 2]
    return username
  }

  // tiktok
  if (url.includes('tiktok.com')) {
    const parts = url.split('/')
    return parts[parts.length - 1]
  }

  // Default case
  return undefined
}

export const textEllipsis = (text: string, maxLength: number) => {
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
}

export const stripHtmlTags = (html: string): string => {
  return html.replace(/<[^>]*>/g, '')
}
